import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { FtModalComponent } from '../../../common/components/modal/ft-modal.component';
import { FtModalChromeComponent } from '../../../common/components/modal/ft-modal-chrome.component';
import { FtDatePickerComponent } from '../../advocacy-group/contest-sheets/podium/ft-date-picker.component';
import { GuestPhotoComponent } from '../components/guest-photo/guest-photo.component';
import { ActivityTypePipe } from '../pipes/activity-type.pipe';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { AdvocatesApiService } from '../services/advocates-api.service';
import { DetailsComponent } from './details.component';
import { PeopleDetailsBodyComponent } from './details-body.component';
import { FtEditGuestDetailsComponent } from './edit-guest-details.component';
import { FtRemoveGuestDetailsComponent } from './remove-guest-details.component';

/**
 * Shared module for the native guest-detail modal (People M5b). The same modal
 * is opened from THREE features — People (`people.directory.details` /
 * `people.feedback.details`), Advocacy (`advocacy.{contests,audiences}.advocate`)
 * and Stories (`stories.details` / `stories.curation.details`) — all routed via
 * the `curationModal.openDetails` handler in angularjs.module.ts. Extracting
 * `DetailsComponent` + its body here lets all three reference the native
 * component (replacing the AngularJS `ftPeopleDetails`) without re-registering
 * routes or duplicating declarations.
 *
 * The body's `| translate` / `| parse` resolve to AccountSharedModule's
 * LegacyTranslate/LegacyParse pipes (PeopleModule's old private FtTranslatePipe
 * /ParsePipe were byte-identical copies and are dropped). `activityType` /
 * `dateFormat` are people-specific so they're declared + exported here (no name
 * clash in advocacy/stories scopes). FtModalComponent is a standalone import.
 */
@NgModule({
  declarations: [
    DetailsComponent,
    PeopleDetailsBodyComponent,
    GuestPhotoComponent,
    ActivityTypePipe,
    DateFormatPipe,
  ],
  imports: [
    CommonModule,
    AccountSharedModule,
    FtModalComponent,
    FtModalChromeComponent,
    FtDatePickerComponent,
    FtEditGuestDetailsComponent,
    FtRemoveGuestDetailsComponent,
  ],
  exports: [
    DetailsComponent,
    PeopleDetailsBodyComponent,
    GuestPhotoComponent,
    ActivityTypePipe,
    DateFormatPipe,
  ],
  providers: [AdvocatesApiService],
})
export class PeopleDetailsModule {}
